import { Heading } from "@bpba/ui-components";
 
type TitleProps = {
  title: string | undefined;
};
 
export const Title = (props: TitleProps) => {
  if (!props || !props.title) return <></>;
 
  return (
    <Heading level={1} fontWeight={400} tabIndex={0}>
      {props.title}
    </Heading>
  );
};